import type { JsonFailure } from '@skynet/data-ws-core';

/** Wording `onError` uses for a failed command that registers no description. */
export const WS_FAILURE_FALLBACK_DESCRIPTION = 'Sorry, an unexpected error has occurred';

/**
 * `getDescription` for `registerErrorMessage`: the server's message, or the
 * generic fallback when it sent none.
 *
 * `message` is optional on the WS failure envelope, so the house
 * `String(json.message)` renders the literal "undefined". A blank message is no
 * better: `useErrorNotification` treats a falsy description as "no description"
 * and replaces the registered title with a bare "Error" (SKY-4581).
 */
export const describeWsFailure = (json: JsonFailure): string =>
  json.message?.trim() ? json.message : WS_FAILURE_FALLBACK_DESCRIPTION;
